import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Features", href: "#features" },
  { label: "Ohio Compliance", href: "#ohio-compliance" },
  { label: "Risk Check", href: "#compliance-quiz" },
  { label: "Product", href: "#product" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white md:bg-white/85 md:backdrop-blur-xl border-b border-stone-200/70" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img src="/logo.svg" alt="ChildCheckOh" className="w-9 h-9 drop-shadow-sm group-hover:scale-105 transition-transform" />
          <span className="font-display text-xl font-semibold tracking-tight text-stone-900">
            ChildCheck <span className="text-emerald-700">Ohio</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-stone-700 hover:text-emerald-700 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="/login"
            data-testid="nav-login-link"
            className="text-sm font-medium text-stone-700 hover:text-stone-900"
          >
            Log in
          </a>
          <Button
            asChild
            data-testid="nav-book-demo-btn"
            className="bg-emerald-700 hover:bg-emerald-800 text-white rounded-xl font-medium px-5 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all"
          >
            <a href="#demo">Book a demo</a>
          </Button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden w-10 h-10 grid place-items-center rounded-lg hover:bg-stone-100"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-stone-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-stone-700 font-medium"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="nav-mobile-book-demo-btn"
              className="bg-emerald-700 hover:bg-emerald-800 text-white rounded-xl"
            >
              <a href="#demo" onClick={() => setOpen(false)}>Book a demo</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
